import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchCartItems } from '../../actions'
import Cart from './Cart'
import ContentLoader from '../global/loaders/ContentLoader'

const CartRedirectHandler = props => {
  const [isLoading, setIsLoading] = useState(true)
  const [showEmptyCart, setShowEmptyCart] = useState(false)

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const result = await dispatch(fetchCartItems())

        if (result?.cart_items?.length > 0 && result?.short_code) {
          history.replace(`/cart/${result.short_code}`)
        } else {
          setShowEmptyCart(true)
          setIsLoading(false)
        }
      } catch (error) {
        setShowEmptyCart(true)
        setIsLoading(false)
      }
    }
    handleRedirect()
  }, [])

  if (isLoading) {
    return <ContentLoader />
  }

  if (showEmptyCart) {
    return <Cart {...props} isEmpty />
  }

  return null
}

export default CartRedirectHandler
